import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import { styled } from '@mui/material';
import { FC, useCallback } from 'react';
import { useCheckForPartiallyCheckedInSets } from 'api/hooks/useCheckForPartiallyCheckedInSets';
import {
  ACTION_ITEMS_INITIAL_FILTERS,
  useActionItemsFilters,
} from 'components/ActionItemsPage/components/ActionItems/hooks/useActionItemsFilters';
import {
  DELIVERIES_INITIAL_FILTERS,
  useDeliveriesFilters,
} from 'components/DeliveryListPage/hooks/useDeliveriesFilters';
import {
  PAST_DELIVERIES_INITIAL_FILTERS,
  usePastDeliveriesFilters,
} from 'components/DeliveryListPage/hooks/usePastDeliveriesFilters';
import { useLanguage } from 'context/AppContext';
import { useAuthorization } from 'hooks/useAuth';
import { useAuth0User } from 'hooks/useAuth0User';
import { PAST_ORDERS_INITIAL_FILTERS, usePastOrdersFilters } from 'pages/SurgeryList/hooks/usePastOrdersFilters';

export const StyledLogoutButton = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  margintop: 5px;
  cursor: pointer;
`;

interface LogoutButtonProps {
  showLabel?: boolean;
}

const LogoutButton: FC<LogoutButtonProps> = ({ showLabel = true }) => {
  const [language] = useLanguage();
  const auth0User = useAuth0User();
  const { login, logout } = useAuthorization();

  const checkForPartiallyCheckedInSets = useCheckForPartiallyCheckedInSets({ showCheckInExitWarningDialog: true });
  const setDeliveriesFilters = useDeliveriesFilters()[1];
  const setPastDeliveriesFilters = usePastDeliveriesFilters()[1];
  const setPastOrdersFilters = usePastOrdersFilters()[1];
  const setActionItemsFilters = useActionItemsFilters()[1];

  const handleLogout = useCallback(() => {
    const doLogout = () => {
      setDeliveriesFilters(DELIVERIES_INITIAL_FILTERS);
      setPastDeliveriesFilters(PAST_DELIVERIES_INITIAL_FILTERS);
      setPastOrdersFilters(PAST_ORDERS_INITIAL_FILTERS);
      setActionItemsFilters(ACTION_ITEMS_INITIAL_FILTERS);

      logout();
    };

    if (checkForPartiallyCheckedInSets(doLogout)) return;

    doLogout();
  }, [
    checkForPartiallyCheckedInSets,
    setDeliveriesFilters,
    setPastDeliveriesFilters,
    setPastOrdersFilters,
    setActionItemsFilters,
    logout,
  ]);

  return auth0User.isAuthenticated ? (
    <StyledLogoutButton onClick={handleLogout}>
      <LogoutIcon key="logout" />
      {showLabel && language.Navigation.logout}
    </StyledLogoutButton>
  ) : (
    <StyledLogoutButton onClick={login as VoidFunction}>
      <LoginIcon key="login" />
      {showLabel && language.Navigation.login}
    </StyledLogoutButton>
  );
};

export default LogoutButton;
